import { DEV_AUTH_ENABLED, DEV_AUTH_ROLE } from "~/constants/mockUserData";
import useCurrentUser from "~/hooks/user/useCurrentUser";

const AdminBarHeadsup: React.FC = () => {
  const { data: currentUser } = useCurrentUser();

  if (DEV_AUTH_ENABLED) {
    return (
      <div className="bg-yellow-500 py-2 text-center text-sm font-bold text-black">
        ⚠️ DEV AUTH BYPASS ACTIVE ({DEV_AUTH_ROLE.toUpperCase()}) - API calls
        will fail
      </div>
    );
  }

  if (currentUser?.role === "admin") {
    return (
      <div className="gap-x-6 bg-gray-900 px-6 py-2.5 text-center sm:px-3.5">
        <p className="text-sm leading-6 text-white">
          You are logged in as an admin
        </p>
      </div>
    );
  }

  return null;
};

export default AdminBarHeadsup;
